exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(true);
// imports


// module
exports.push([module.id, "\n[dir=\"ltr\"] .btn-open-lang[data-v-1caa8ccf]{margin-left:0.93333rem\n}\n[dir=\"rtl\"] .btn-open-lang[data-v-1caa8ccf]{margin-right:0.93333rem\n}\n.autoHeight[data-v-1caa8ccf]{margin-top:2.34667rem !important\n}\n", "", {"version":3,"sources":["D:/TsWeb/h5aliex/src/compontents/newHome/InCompleteSiteHead.vue"],"names":[],"mappings":";AAAA,4CAA2B,sBAAgB;CAAC;AAAA,4CAA2B,uBAAiB;CAAC;AAAA,6BAAY,gCAA0B;CAAC","file":"InCompleteSiteHead.vue","sourcesContent":["[dir=\"ltr\"] .btn-open-lang{margin-left:35px}[dir=\"rtl\"] .btn-open-lang{margin-right:35px}.autoHeight{margin-top:88px !important}\n"],"sourceRoot":""}]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?sourceMap!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-1caa8ccf","scoped":true,"hasInlineConfig":false}!./node_modules/sass-loader/dist/cjs.js!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/compontents/newHome/InCompleteSiteHead.vue
// module id = R7Hy
// module chunks = 0